<template>
  <div>
    <base-confirm
      :visible="visible"
      icon-type="badge"
      type="success"
      size="max-w-lg"
      title="Terima Pengiriman Barang"
      message="Apakah anda yakin ingin menerima pengiriman barang ini? Jika terdapat komplain isi deskripsi dan upload bukti komplain pada form di bawah ini"
      confirm-text="Terima"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      @opened="onOpened"
    >
      <template #content>
        <base-input
          fullwidth
          :shadow="false"
          type="text"
          inset
          label="Deskripsi Komplain"
          placeholder="Deskripsi Komplain"
          tag="textarea"
          rows="4"
          v-model="form.complain_description"
        />
        <base-input
          fullwidth
          :shadow="false"
          type="file"
          size="padding-md"
          inset
          label="Bukti Komplain"
          accept="image/*"
          @change="onChangeComplainImage"
        />
      </template>
    </base-confirm>

    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';
import BaseConfirm from '../base/BaseConfirm.vue';

export default {
  mixins: [requestMixin],
  components: { BaseConfirm },
  props: {
    visible: Boolean,
    stockMovementId: String,
  },
  emits: ['close', 'received'],
  data() {
    return {
      loading: false,
      form: {
        complain_description: null,
        complain_image: null,
      },
    };
  },
  methods: {
    onOpened() {
      this.form.complain_description = null;
      this.form.complain_image = null;
    },
    onChangeComplainImage(e) {
      this.form.complain_image = e.target.files[0];
    },
    async onConfirmed() {
      this.loading = true;

      const formData = new FormData();

      if (this.form.complain_description) {
        formData.append('complain_description', this.form.complain_description);
      }

      if (this.form.complain_image) {
        formData.append('complain_image', this.form.complain_image);
      }

      const [, err] = await this.request(
        `/api/v1/stock-movements/${this.stockMovementId}/-actions/receive-with-complain`,
        {
          method: 'post',
          data: formData,
        }
      );

      if (!err) {
        this.$emit('received');
      }

      this.loading = false;
    },
  },
};
</script>
